import React from 'react'
import { useHistory } from 'react-router-dom'
import { RightOutlined } from '@ant-design/icons'
import './index.less'

interface DividerProps {
  title?: React.ReactNode
  productCode?: string
  showMore?: boolean
}

export default function Divider({
  title,
  productCode,
  showMore = true,
}: DividerProps) {
  const history = useHistory()

  const openMore = () => {
    history.push(`/search?c=${productCode}&page=1&type=app`)
  }

  return (
    <div className="home-divider">
      <span className="home-divider-title">{title}</span>
      {showMore && (
        <div className="home-divider-more">
          <span className="home-divider-more-text" onClick={openMore}>
            查看更多
          </span>
          <RightOutlined className="home-divider-more-icon" />
        </div>
      )}
    </div>
  )
}
